import { Component, OnInit, ViewChild } from '@angular/core';
import { PostService } from '@app/services/social/post.service';
import { PostListComponent } from '../post/post-list/post-list.component';
import { ModuleService } from '@modules/application/services/module.service';
import { SocialLocalModule } from '@modules/social/social-local.module';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-feeds',
  providers: [PostService],
  templateUrl: './feeds.component.html',
})
export class FeedsComponent implements OnInit {
  constructor(private moduleService: ModuleService) {}

  @ViewChild(PostListComponent, {static: false}) postList: PostListComponent;

  loadingPosts = false;
  moduleAvailable$: Observable<boolean> = this.moduleService.isModuleAvailable(SocialLocalModule.code);

  ngOnInit() {}

  getNewFeeds() {
    if (this.postList) {
      this.postList.getNewFeeds();
    }
  }

  onLastPost = newPost => {
    if (this.postList) {
      this.postList.insertLastPost(newPost);
    }
  }
}
